import React from 'react';
import { useIntl } from 'react-intl';
import type { StudioThemeId } from 'fym-shared/src/music24/studioThemes';
import { TypedMemo } from '../../../common/types';
import type { StudioThemeState } from './studioRules';
import { FullVideoPlanNote } from './FullVideoPlanNote';
import { fullVideoMessages } from './fullVideoMessages';
import type { SongLyricsView } from '../../../smartLinks/catalog/song/page/catalogSongPath';

interface ThemeCardNoteProps {
  themeId: StudioThemeId;
  state: StudioThemeState;
  isOwner: boolean;
  /** Opens the Lyrics section of the song page in Catalog, where the lyrics are added. */
  onOpenSongLyrics: (view?: SongLyricsView) => void;
}

/**
 * The line under a step-2 card that is shut or limited (design s7c): "Add the lyrics" for a song
 * with no lyrics, the Artist plan note on Free (a full video, the motion artwork), and the wait for the clip bank of the music video.
 * Null for the other states (their chip says enough).
 */
const ThemeCardNoteComponent: React.FC<ThemeCardNoteProps> = ({ themeId, state, isOwner, onOpenSongLyrics }) => {
  const intl = useIntl();

  switch (state) {
    case 'needsLyrics':
      return (
        <span>
          {intl.formatMessage(fullVideoMessages.needsLyricsBody)}{' '}
          <button
            type="button"
            className="btn btn-link btn-sm p-0 align-baseline"
            onClick={() => onOpenSongLyrics('text')}
          >
            {intl.formatMessage(fullVideoMessages.addLyrics)}
          </button>
        </span>
      );
    case 'needsPlan':
      return <FullVideoPlanNote themeId={themeId} isOwner={isOwner} />;
    case 'open':
    case 'needsMaster':
    case 'needsReleaseDate':
      return null;
  }
};

export const ThemeCardNote = TypedMemo(ThemeCardNoteComponent);
